import { AppAction } from '@app/actions/app-action';
import { AppActions } from '@app/app-actions.enum';
import { ClientStateState, initialState } from './client-state-state';
import { ClientStateStatus } from './client-state-status';

export function clientStateReducer(
  state: ClientStateState = initialState,
  action: AppAction,
): ClientStateState {
  switch (action.type) {
    case AppActions.LOAD_STATE_REQUEST:
      return { ...state, status: ClientStateStatus.Loading };
    case AppActions.LOAD_STATE_SUCCESS:
      return { ...state, status: ClientStateStatus.SuccessFullyLoaded };
    case AppActions.LOAD_STATE_FAILURE:
      return { ...state, status: ClientStateStatus.FailedToLoad };
    default:
      return state;
  }
}
